import { useEffect } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import { POPOVERS } from 'EmailEditorUI/constants/PopoversConstants';
import { getOpenedPopover } from 'EmailEditorUI/redux/selectors/AppStateSelectors';
import { getIsEditorDarkModeEnabled } from 'EmailEditorUI/redux/selectors/darkModeSelectors';
import { useAppSelector } from 'LayoutBuilderUI/reducers/rootReducer';
const ignoreInlineStyle = ['.mce-token', '#comment-indicator', '[data-test-id="affordance"]', '.hs_cos_unresolved_hubl_module *'];
const ignoreImageAnalysis = ['#cos_layout_builder'];
function importDarkreader() {
  return import( /* webpackChunkName: 'darkreader' */'darkreader');
}
function toggleDarkreaderClasses(enabled) {
  const styledElements = Array.from(document.querySelectorAll('style[data-hubspot-styled-components], link[rel]'));
  styledElements.forEach(style => {
    style.classList.toggle('darkreader', enabled);
  });
}
async function enableDarkMode() {
  const darkreader = await importDarkreader();
  toggleDarkreaderClasses(true);
  darkreader.setFetchMethod(window.fetch);
  darkreader.enable({
    brightness: 100,
    contrast: 90,
    sepia: 10
  }, {
    ignoreInlineStyle,
    css: '',
    ignoreImageAnalysis,
    invert: [],
    disableStyleSheetsProxy: false
  });
}
async function disableDarkMode() {
  const darkreader = await importDarkreader();
  toggleDarkreaderClasses(false);
  darkreader.disable();
}
function DarkReaderScript() {
  const isDarkModeEnabled = useAppSelector(getIsEditorDarkModeEnabled);
  const prevIsDarkModeEnabled = usePrevious(isDarkModeEnabled);
  const isEmailEditorDisplayOptionsPopoverOpen = useAppSelector(state => getOpenedPopover(state) === POPOVERS.EMAIL_EDITOR_DISPLAY_OPTIONS);
  useEffect(() => {
    if (isEmailEditorDisplayOptionsPopoverOpen) {
      void importDarkreader();
    }
  }, [isEmailEditorDisplayOptionsPopoverOpen]);
  useEffect(() => {
    if (isDarkModeEnabled) {
      void enableDarkMode();
    } else if (prevIsDarkModeEnabled) {
      void disableDarkMode();
    }
  }, [isDarkModeEnabled, prevIsDarkModeEnabled]);
  return null;
}
export default DarkReaderScript;